import React from 'react';
import './Paragraph.css'

const Paragraph = (props) => {
    return (
      <>
        {props.text1 && <div className={props.css5}>{props.text1}</div>}
        {props.text2 && <div className={props.css7}>{props.text2}</div>}
        {props.text3 && <div className={props.css9}>{props.text3}</div>}
        {props.text4 && <div className={props.css12}>{props.text4}</div>}
      </>
    );
  }
 
export default Paragraph;